import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { Button, ButtonGroup } from '@mui/material';
import {
    Grid,
    Divider,
    Alert
} from '@mui/material';
import { payActionsSaga } from '../../../../infrastructure/services/pay'
import { payActions } from '../../../../application/actions/pay';
import CreateForms from '../../organismos/forms';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import {IntlNumberFormat} from '../../../../utils/helpers'
import entity from './entity';


export default function Pay({ data, state }) {
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(true)
    const [pay, setPay] = useState({})
    const { result: resultCreate, connection: connectionPayCreate } = useSelector((store) => store.tk.pay.create);
    const { data: dataGetById } = useSelector((store) => store.tk.pay.getById);


    const handlerChange = () => {
        dispatch(payActionsSaga.create(pay))
    }

    const getFieldsPay = (fields) => {
        console.log(fields)
        const pay = { caseId: data.idcase }
        fields.map((F) => F.groups.map(G => G.display && G.fields.map(F => pay[F.id] = F.value)))
        setPay({ data: pay });
    }

    const getEnableFieldsPay = (flag) => {
        setDisabled(!flag)
    }

    const handlergetById = () => {
        dispatch(payActionsSaga.getById({ id: data.idcase }))
    }

    useEffect(() => {
        dispatch(payActions.createGetByIdReset())
        handlergetById()
    }, [])

    useEffect(() => {
        resultCreate && handlergetById()
        resultCreate && dispatch(payActions.createReset())
    }, [resultCreate])

    const buildPayTable = () => {
        let total =0;
        dataGetById.map(pay=> total = total+pay.amount)
        const table = <TableContainer sx={{ m: 1 }} component={Paper}>
            <Table sx={{ minWidth: '100%', maxHeight:'' }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Detalle</TableCell>
                        <TableCell align="right">Monto</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dataGetById.map((row) => (
                        <TableRow
                            key={row.userId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <Box>
                                    {row.userFullName}
                                </Box>

                                <Box sx={{ mb: 0, mt: 0 }}>
                                    <Typography sx={{ fontSize: 15 }} >{`Realiazdo el: ${moment(row.date).format('DD/MM/YYYY - HH:MM')}`}</Typography>
                                </Box>
                                <Box sx={{ mb: 0, mt: 0 }}>
                                    <Typography sx={{ fontSize: 15 }} >{row.coment}</Typography>
                                </Box>

                            </TableCell>


                            <TableCell align="right">{IntlNumberFormat(row.amount)}</TableCell>
                        </TableRow>
                    ))}
                    <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Box sx={{ mb: 0, mt: 0 }}>
                                <Typography sx={{ fontSize: 20 }} >Total recaudado</Typography>
                            </Box>
                        </TableCell>
                        <TableCell align="right"><Typography sx={{ fontSize: 20, fontWeight:'bold' }} >{IntlNumberFormat(total)}</Typography></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        return table

    }

    return (

        <Grid container>
            <Grid xs={12} sm={6} md={6}>
                <Card sx={{ m: 1 }} >
                    <CardHeader
                        title='Registrar pagos'
                    />
                    <Divider />
                    <CardContent>
                        {!connectionPayCreate && <CreateForms
                            fields={entity.formulario}
                            getFields={getFieldsPay}
                            getEnabledForm={getEnableFieldsPay}
                            sxfields={{ mt: 0 }}
                        />}
                    </CardContent>
                    <Divider />
                    <CardActions>
                        <ButtonGroup fullWidth variant="contained" aria-label="Basic button group">
                            <Button disabled={disabled} color="success" onClick={() => handlerChange()}>Registrar Pago</Button>
                        </ButtonGroup>
                    </CardActions>
                </Card>
            </Grid>
            <Grid xs={12} sm={6} md={6}>
                {buildPayTable()}
            </Grid>
        </Grid>
    );
}